<template>
	<view>
		<view class="card" >
			{{ message.text }}
		</view>
	</view>
</template>

<script>
import { parseGroupSystemNotice } from '../../../base/message-facade';
import { caculateTimeago } from '../../../base/common';

export default {
	data() {
		return {
			messageTime: '',
			renderDom: ''
		};
	},

	components: {},
	props: {
		message: {
			type: Object
		}
	},

	methods: {
		
	}
};
</script>
<style scoped>

.handle {
	display: flex;
	justify-content: space-between;
}

.card {
	font-size: 24px;
	margin: 20px 40px;
	padding: 10px 20px;
	box-sizing: border-box;
	background-color: #f0faff;
	border-radius: 12px;
	line-height: 1.5;
}

.time {}

.button {
	color: blue;
	border-radius: 8px;
	line-height: 30px;
	font-size: 16px;
	width: 70px;
}

</style>
